// MOMBI — custom thema-script
// Bewust minimaal gehouden voor snelheid; formulieren werken ook zonder JS
// (progressive enhancement), dit script voegt alleen visuele feedback toe.
document.documentElement.classList.add('js-enabled');

// Werkt het winkelwagen-icoontje in de header bij zonder de pagina te herladen —
// nodig omdat de kruiden-quiz in een overlay blijft staan na het toevoegen van een los kruid.
function updateCartCount() {
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    })
    .catch(function () {});
}

document.querySelectorAll('.newsletter__form').forEach(function (form) {
  form.addEventListener('submit', function () {
    var btn = form.querySelector('button[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Even geduld…';
    }
  });
});

// Aantal-stepper op de productpagina
document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
  var input = stepper.querySelector('.qty-stepper__input');
  var dec = stepper.querySelector('[data-qty-decrease]');
  var inc = stepper.querySelector('[data-qty-increase]');
  if (!input || !dec || !inc) return;

  function setValue(val) {
    var min = parseInt(input.min, 10) || 1;
    input.value = Math.max(min, val);
  }

  dec.addEventListener('click', function () {
    setValue((parseInt(input.value, 10) || 1) - 1);
  });
  inc.addEventListener('click', function () {
    setValue((parseInt(input.value, 10) || 1) + 1);
  });
  input.addEventListener('change', function () {
    setValue(parseInt(input.value, 10) || 1);
  });
});

// Formaat-kiezer (Standaard / Minder / Meer) op de productpagina:
// werkt de verborgen variant-id en de getoonde prijs bij zodra de klant een andere hoeveelheid kiest.
document.querySelectorAll('.product__variant-picker').forEach(function (picker) {
  picker.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('.variant-pill__input')) return;

    var form = picker.closest('.product__form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = document.querySelector('.product__price-sale');

    if (idInput) idInput.value = input.value;
    if (priceEl && input.dataset.variantPrice) {
      priceEl.textContent = input.dataset.variantPrice;
    }

    picker.querySelectorAll('.variant-pill').forEach(function (pill) {
      pill.classList.remove('variant-pill--active');
    });
    var activePill = input.closest('.variant-pill');
    if (activePill) activePill.classList.add('variant-pill--active');
  });
});

// Productformulier: voegt hoofdproduct + gekozen extra's in één keer toe aan de winkelwagen
// en stuurt daarna direct door naar checkout (minder stappen = minder afhakers).
var productForm = document.querySelector('.product__form');
if (productForm) {
  productForm.addEventListener('submit', function (e) {
    e.preventDefault();

    var submitBtn = productForm.querySelector('.product__buy');
    var errorEl = productForm.querySelector('.product__form-error');
    var idInput = productForm.querySelector('input[name="id"]');
    var qtyInput = productForm.querySelector('input[name="quantity"]');
    if (!idInput || !idInput.value) return;

    var items = [
      { id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }
    ];
    productForm.querySelectorAll('.extra-card__checkbox:checked').forEach(function (cb) {
      var vid = cb.getAttribute('data-extra-variant-id');
      if (vid) items.push({ id: parseInt(vid, 10), quantity: 1 });
    });

    if (submitBtn) {
      submitBtn.dataset.originalText = submitBtn.dataset.originalText || submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Toevoegen…';
    }
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error((data && data.description) || 'Kon niet worden toegevoegd aan de winkelwagen.');
          });
        }
        return res.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.originalText;
        }
        if (errorEl) {
          errorEl.textContent = err.message || 'Er ging iets mis. Probeer het opnieuw.';
          errorEl.hidden = false;
        }
      });
  });
}

// "Combineert goed met" — snel een bijpassend kruid toevoegen vanaf de productpagina van een ander kruid.
document.querySelectorAll('[data-pairing-add]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var defaultText = btn.getAttribute('data-default-text') || btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Toevoegen…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error((data && data.description) || 'Kon niet worden toegevoegd.');
          });
        }
        return res.json();
      })
      .then(function () {
        btn.textContent = 'Toegevoegd ✓';
        window.setTimeout(function () {
          window.location.reload();
        }, 700);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Mislukt — probeer opnieuw';
        window.setTimeout(function () {
          btn.textContent = defaultText;
        }, 2000);
      });
  });
});

// Kruiden-quiz: één vraag per keer met voortgangsbalk, resulterend in een aanbevolen kruidenpakket.
// LET OP: de labels die op de kruiden-collectiepagina getoond worden (sections/collection-main.liquid)
// zijn een aparte, handmatige weergave van deze BUNDLES-indeling — bij wijzigingen hier ook daar bijwerken.
(function () {
  var overlay = document.getElementById('kruiden-quiz');
  if (!overlay) return;

  var openBtn = document.querySelector('[data-quiz-open]');
  var closeBtn = overlay.querySelector('[data-quiz-close]');
  var body = overlay.querySelector('[data-quiz-body]');
  var fill = overlay.querySelector('[data-quiz-progress-fill]');
  var label = overlay.querySelector('[data-quiz-progress-label]');

  var dataEl = document.getElementById('quiz-product-data');
  var PRODUCTS = {};
  try {
    PRODUCTS = dataEl ? JSON.parse(dataEl.textContent) : {};
  } catch (e) {
    PRODUCTS = {};
  }

  var BUNDLES = {
    rustig: {
      title: 'Rustig & Slaperig',
      description: 'Voor avonden waarop je hoofd nog vol zit en je lichaam wil ontspannen richting een goede nachtrust.',
      handles: ['lavendel-bloesem-gedroogd', 'kamille-bloesem-gedroogd', 'rozenblaadjes-gedroogd']
    },
    actief: {
      title: 'Actieve Voeten',
      description: 'Verzacht vermoeide of pijnlijke voeten na een lange dag op de been of een stevige training.',
      handles: ['rozemarijn-gedroogd', 'pepermunt-gedroogd', 'epsom-badzout-500g', 'gemberpoeder']
    },
    reset: {
      title: 'Mentale Reset',
      description: 'Een fris, helder moment tussen de bedrijven door — geen slaapmiddel, maar een oppepper voor je hoofd.',
      handles: ['eucalyptusblad-gedroogd', 'etherische-olie-set-lavendel-eucalyptus', 'pepermunt-gedroogd']
    },
    verwen: {
      title: 'Verwenmoment',
      description: 'Een klein spa-moment thuis — een zachte huid en een luxe gevoel, gewoon omdat je het verdient.',
      handles: ['rozenblaadjes-gedroogd', 'dode-zeezout-500g', 'etherische-olie-set-lavendel-eucalyptus']
    },
    frisstart: {
      title: 'Frisse Start',
      description: 'Voor als je liever geen onzeker gevoel overhoudt aan een lange dag in gesloten schoenen — verkoelend, mineraalrijk en gericht op een fris, schoon gevoel voor huid en nagels.',
      handles: ['eucalyptusblad-gedroogd', 'dode-zeezout-500g', 'pepermunt-gedroogd']
    }
  };

  var QUESTIONS = [
    {
      text: 'Wat wil je vooral bereiken met je voetenbad?',
      options: [
        { label: 'Eindelijk weer goed slapen', scores: { rustig: 3 } },
        { label: 'Vermoeide of pijnlijke voeten verzachten', scores: { actief: 3 } },
        { label: 'Mentaal resetten na een drukke dag', scores: { reset: 3 } },
        { label: 'Mezelf verwennen, gewoon omdat het kan', scores: { verwen: 3 } }
      ]
    },
    {
      text: 'Wanneer gebruik je je voetenbad meestal?',
      options: [
        { label: "'s Avonds, vlak voor het slapengaan", scores: { rustig: 2 } },
        { label: 'Na het sporten of een lange dag op de been', scores: { actief: 2 } },
        { label: 'Overdag, als korte reset tussen taken door', scores: { reset: 2 } },
        { label: 'In het weekend, als bewust verwenmoment', scores: { verwen: 2 } }
      ]
    },
    {
      text: 'Heb je een specifieke zorg over je voeten waar je iets aan wilt doen?',
      options: [
        { label: 'Een onzeker gevoel over geur, vooral na een lange dag in de schoenen', scores: { frisstart: 3 } },
        { label: 'Jeuk of een geïrriteerd gevoel aan mijn voeten', scores: { frisstart: 2, rustig: 1 } },
        { label: 'Nagels of eelt die wel wat extra verzorging kunnen gebruiken', scores: { verwen: 2, frisstart: 1 } },
        { label: 'Nee, ik zoek vooral gewoon ontspanning', scores: {} }
      ]
    },
    {
      text: 'Welke geur spreekt je het meest aan?',
      options: [
        { label: 'Bloemig en zacht', scores: { rustig: 2, verwen: 1 } },
        { label: 'Fris en kruidig', scores: { reset: 2, frisstart: 1 } },
        { label: 'Warm en aards', scores: { actief: 2 } },
        { label: 'Maakt me niet uit, als het maar werkt', scores: {} }
      ]
    },
    {
      text: 'Hebben je voeten extra verzorging nodig, of is warm water met kruiden voor jou al genoeg?',
      options: [
        { label: 'Extra verzorging mag zeker', scores: { verwen: 2 } },
        { label: 'Warm water met kruiden is voor mij genoeg', scores: {} }
      ]
    }
  ];

  var current = 0;
  var scores = {};

  function resetQuiz() {
    current = 0;
    scores = { rustig: 0, actief: 0, reset: 0, verwen: 0, frisstart: 0 };
  }

  function updateProgress(step, total) {
    var pct = Math.round((step / total) * 100);
    if (fill) fill.style.width = pct + '%';
    if (label) label.textContent = step < total ? ('Vraag ' + (step + 1) + ' van ' + total) : 'Klaar!';
  }

  function renderQuestion() {
    var q = QUESTIONS[current];
    updateProgress(current, QUESTIONS.length);

    var html = '<p class="quiz-question">' + q.text + '</p><div class="quiz-options">';
    q.options.forEach(function (opt, i) {
      html += '<button type="button" class="quiz-option" data-quiz-answer="' + i + '">' + opt.label + '</button>';
    });
    html += '</div>';
    if (current > 0) {
      html += '<button type="button" class="quiz-back" data-quiz-back>← Vorige vraag</button>';
    }
    body.innerHTML = html;

    body.querySelectorAll('[data-quiz-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var opt = q.options[parseInt(btn.getAttribute('data-quiz-answer'), 10)];
        Object.keys(opt.scores || {}).forEach(function (key) {
          scores[key] = (scores[key] || 0) + opt.scores[key];
        });
        current++;
        if (current >= QUESTIONS.length) {
          renderResult();
        } else {
          renderQuestion();
        }
      });
    });

    var backBtn = body.querySelector('[data-quiz-back]');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        current--;
        renderQuestion();
      });
    }
  }

  function rankedBundles() {
    var keys = Object.keys(BUNDLES);
    keys.sort(function (a, b) {
      return (scores[b] || 0) - (scores[a] || 0);
    });
    return keys;
  }

  function productCardHtml(handle) {
    var p = PRODUCTS[handle];
    if (!p) return '';
    var priceText = p.priceVaries ? ('vanaf ' + p.priceMin) : p.price;
    return (
      '<div class="pairing-card">' +
      (p.image ? '<img class="pairing-card__image" src="' + p.image + '" alt="' + p.title + '" loading="lazy" width="56" height="56">' : '') +
      '<div class="pairing-card__info">' +
      '<a href="' + p.url + '" class="pairing-card__name">' + p.title + '</a>' +
      '<span class="pairing-card__price">' + priceText + '</span>' +
      '</div>' +
      '<button type="button" class="button button--ghost button--small quiz-add" data-quiz-add data-variant-id="' + p.variantId + '" data-default-text="+ Toevoegen">+ Toevoegen</button>' +
      '</div>'
    );
  }

  function renderResult() {
    updateProgress(QUESTIONS.length, QUESTIONS.length);
    var ranked = rankedBundles();
    var primaryKey = ranked[0];
    var secondaryKey = ranked[1];
    var primary = BUNDLES[primaryKey];
    var secondary = BUNDLES[secondaryKey];

    var html = '<p class="quiz-result-eyebrow">Dit past bij jou</p>';
    html += '<h3 class="quiz-result-title">' + primary.title + '</h3>';
    html += '<p class="quiz-result-text">' + primary.description + '</p>';
    html += '<div class="pairings-grid quiz-result-grid">';
    primary.handles.forEach(function (h) {
      html += productCardHtml(h);
    });
    html += '</div>';

    if (secondary && (scores[secondaryKey] || 0) > 0) {
      var secondaryNames = secondary.handles
        .map(function (h) { return PRODUCTS[h] ? PRODUCTS[h].title : ''; })
        .filter(Boolean)
        .join(' + ');
      html += '<p class="quiz-result-alt">Past ook goed bij je: <strong>' + secondary.title + '</strong> (' + secondaryNames + ')</p>';
    }

    if (primary.handles.indexOf('gemberpoeder') === -1) {
      html += '<p class="quiz-result-tip">Tip: voeg een snufje gemberpoeder toe aan elk kruidenpakket voor extra warmte.</p>';
    }

    html += '<div class="quiz-result-actions">';
    html += '<button type="button" class="button button--primary quiz-add-all" data-quiz-add-all data-default-text="Voeg hele pakket toe aan winkelwagen">Voeg hele pakket toe aan winkelwagen</button>';
    html += '<button type="button" class="button button--ghost button--small" data-quiz-restart>Opnieuw doen</button>';
    html += '</div>';
    html += '<p class="quiz-add-all-error" role="alert" hidden></p>';

    body.innerHTML = html;

    body.querySelectorAll('[data-quiz-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || variantId === 'undefined') return;

        var defaultText = btn.getAttribute('data-default-text') || btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Toevoegen…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error((data && data.description) || 'Kon niet worden toegevoegd.');
              });
            }
            return res.json();
          })
          .then(function () {
            btn.textContent = 'Toegevoegd ✓';
            updateCartCount();
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = 'Mislukt — probeer opnieuw';
            window.setTimeout(function () {
              btn.textContent = defaultText;
            }, 2000);
          });
      });
    });

    // Eén knop om het hele aanbevolen kruidenpakket (alle kruiden van deze uitkomst) in één keer
    // aan de winkelwagen toe te voegen, in plaats van elk kruid los te moeten aanklikken.
    var addAllBtn = body.querySelector('[data-quiz-add-all]');
    var addAllError = body.querySelector('.quiz-add-all-error');
    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        var items = primary.handles
          .map(function (h) { return PRODUCTS[h]; })
          .filter(function (p) { return p && p.available && p.variantId && p.variantId !== 'undefined'; })
          .map(function (p) { return { id: parseInt(p.variantId, 10), quantity: 1 }; });

        if (!items.length) return;

        var defaultText = addAllBtn.getAttribute('data-default-text') || addAllBtn.textContent;
        addAllBtn.disabled = true;
        addAllBtn.textContent = 'Toevoegen…';
        if (addAllError) {
          addAllError.textContent = '';
          addAllError.hidden = true;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error((data && data.description) || 'Kon niet worden toegevoegd aan de winkelwagen.');
              });
            }
            return res.json();
          })
          .then(function () {
            addAllBtn.textContent = 'Toegevoegd ✓';
            updateCartCount();
            window.setTimeout(function () {
              window.location.href = '/cart';
            }, 500);
          })
          .catch(function (err) {
            addAllBtn.disabled = false;
            addAllBtn.textContent = defaultText;
            if (addAllError) {
              addAllError.textContent = err.message || 'Er ging iets mis. Probeer het opnieuw.';
              addAllError.hidden = false;
            }
          });
      });
    }

    var restartBtn = body.querySelector('[data-quiz-restart]');
    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        resetQuiz();
        renderQuestion();
      });
    }
  }

  function openQuiz() {
    resetQuiz();
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    renderQuestion();
  }

  function closeQuiz() {
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  if (openBtn) openBtn.addEventListener('click', openQuiz);
  if (closeBtn) closeBtn.addEventListener('click', closeQuiz);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeQuiz();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) closeQuiz();
  });

  // Staat een link elders op de site (bv. de homepage-teaser) toe om direct naar de
  // collectiepagina + geopende quiz te linken via een #kruiden-quiz hash-link.
  if (window.location.hash === '#kruiden-quiz') {
    openQuiz();
  }
})();
